import isStringValidNum from './isStringValidNum';
export default function floatToFixed(float: string): number | string {
  if (!isStringValidNum(float)) {
    return float;
  }

  return parseFloat(float).toFixed(2);
}
